import { Card, CardContent } from '@mui/material';
import EditDeviceList from 'components/EditDeviceList';
import EditStations from 'components/EditStations';
import EditScriptList from 'components/EditScriptList';
import GlobalScriptFlowCard from './GlobalScriptFlowCard/GlobalScriptFlowCard';

const ScriptManager = () => {
  return (
    <div className="flex flex-col w-full gap-6 min-w-0">
      <Card>
        <CardContent>
          <EditDeviceList />
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <EditStations />
        </CardContent>
      </Card>
      <Card className="overflow-x-auto">
        <CardContent>
          <EditScriptList />
        </CardContent>
      </Card>
      <GlobalScriptFlowCard />
    </div>
  );
};

export default ScriptManager;
